import React, {useEffect, useState} from "react";
import WishlistItem from "./WishlistItem/WishlistItem";
import {useTranslation} from "react-i18next";
import styles from "./Wishlist.module.scss";
import {getShopId} from "../lib/getShopId";
import {BrowserStorage} from "../../storage/BrowserStorage";
import {useCustomerSelector, useWishlistSelector} from "../../store";

export const scrollInfoStorage = new BrowserStorage<{itemId: number; index: number}>({
  type: "sessionStorage",
  dataIdentifier: "wishlist",
});

const Wishlist: React.FC = () => {
  const {wishlist} = useWishlistSelector();
  const {t} = useTranslation();
  const [maxItems, setMore] = useState(20);
  const {customer} = useCustomerSelector();

  useEffect(() => {
    if (wishlist?.items.length) {
      const scrollInfo = scrollInfoStorage.read("scrollInfo");
      if (scrollInfo) {
        const {index} = scrollInfo;
        if (wishlist) {
          setMore(index >= 20 ? wishlist.items.length : 20);
        }
      }
    }
  }, [wishlist?.items.length]);

  const wishlistDiv = document.getElementsByClassName("wishlist")[0];
  const spinner = document.querySelector(".wishlist > .swiper-lazy-preloader");
  if (spinner) {
    wishlistDiv.removeChild(spinner);
  }

  // show content when no items exists and the customer is logged in
  if (!wishlist?.items.length && customer.isRecognised) {
    return (
      <div className={styles.noListWrapper}>
        {t("wishlist.currentlyNoItems")}
        <br />
        {t("wishlist.productRangeInspiration")}
        <br />
        <a href={window.location.origin}>
          {t("wishlist.findDesignFavourites").replace("favourites", getShopId() === 10005 ? "favorites" : "favourites")}
        </a>
      </div>
    );
  }

  if (!wishlist?.items.length) {
    return null;
  }

  const itemsSortByModified =
    wishlist?.items.sort((a, b) => {
      if (a.modified < b.modified) {
        return 1;
      } else if (a.modified > b.modified) {
        return -1;
      } else {
        return 0;
      }
    }) || [];

  return (
    <React.Fragment>
      {/*/ sorted wishlist items */}
      <div>
        {itemsSortByModified.map((item, index) => {
          if (index < maxItems) {
            return <WishlistItem key={item.item.itemId} item={item} index={index} />;
          } else {
            return null;
          }
        })}
      </div>

      {/*/ "mehr laden" button  */}
      {itemsSortByModified.length > maxItems && (
        <div className={styles.moreButtonWrapper}>
          <button
            className={styles.moreButton}
            onClick={() => {
              setMore(itemsSortByModified.length);
            }}
          >
            {t("wishlist.showAllItems")}
          </button>
        </div>
      )}
    </React.Fragment>
  );
};

export default Wishlist;
